module.exports = __webpack_public_path__ + "static/img/menu-open.ea459c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/element/Menu/img/menu-open.png
// module id = 516
// module chunks = 0